import React, { ReactElement } from 'react'
import { useTranslation } from 'next-i18next'
import { TermLink, TermLinkProps } from '../TermLink'
import { useAmplitudeWithEnduringEventProperties } from '../../integrations/amplitude'
import { TrackingEvent } from '../../model/amplitude'

interface UseSignUpTermsResult {
  readonly [tagName: string]: ReactElement<TermLinkProps>
}

export const useSignUpTerms = (): UseSignUpTermsResult => {
  const { t } = useTranslation()
  const { logEvent } = useAmplitudeWithEnduringEventProperties()
  return {
    terms: (
      <TermLink
        key='sign-up-terms-of-service'
        href={t('common:urls:termsOfServiceUrl')}
        color='Orca'
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'terms_of_service' })
        }}
      />
    ),
    consent: (
      <TermLink
        key='payment-options-consent'
        color='Orca'
        href={`${t('common:urls:termsOfServiceUrl')}#e-sign`}
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'payment_options_consent' })
        }}
      />
    ),
    privacy: (
      <TermLink
        key='sign-up-privacy-policy'
        href={t('common:urls:privacyPolicyUrl')}
        color='Orca'
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'privacy_policy' })
        }}
      />
    ),
    optOut: (
      <TermLink
        key='sign-up-opt-out'
        href={t('common:urls:marketingOptOutUrl')}
        onClick={() => {
          logEvent(TrackingEvent.CLICKED_TERM_LINK, { type: 'marketing_opt_out' })
        }}
      />
    ),
  }
}
